import { SCHEDULE_SESSION_DISPLAY_TYPE_ROUND } from '../constants';

/**
 * Returns true for sessions that are in the user schedule
 * Rounds and unselected sessions are ignored
 *
 * @param {object} session Session to check
 * @returns boolean
 */
export function isRealUserSchedule(session) {
    return (session.is_selected || !session.is_selectable) && !session.display_category && session.display_type != SCHEDULE_SESSION_DISPLAY_TYPE_ROUND;
}
